<template>
  <div id="quotation-container" v-if="infocar">
    <div id="quotation-inner-cont" class="container-general">
      <div class="block-left">
        <h1 :class="['car_name', 'title', quotationColor]">{{ infocar.nome }}</h1>
        <div class="car_data text-align-right">
          <div class="title_table row_data" v-if="vehicle_type==='1'">
            <div :class="[quotationColor]" >Dati veicolo</div>
            <img :src="iconType" alt="" width="80" />
          </div>
          <div class="title_table row_data" v-else-if="vehicle_type==='2'">
            <div :class="[quotationColor]" >Dati veicolo</div>
            <img :src="iconTypeVComm" alt="" width="80" />
          </div>
          <div v-for="(item, index) in vehicleData" :key="index" class="row_data">
            <div class="data_title">{{ item.label }}</div>
            <div class="data_content">{{ item.value }}</div>
          </div>
        </div>
      </div>
      <div class="block-right">
        <div class="text-align-center logo-cont-quotation">
          <img :src="logoType" alt="" width="280" />
        </div>
        <div class="container-real-quotation" :class="[quotationBorder]">
          <div class="container-real-quotation-top">
            <div class="title-real-quotation" :class="[quotationColor]">
              QUOTAZIONE EFFETTIVA PER CESSIONE A PRIVATO
            </div>
            <div class="content-real-quotation" :class="[quotationColor]">
              {{ formatNumber(prezziVendere.valorePrivato) }} €
            </div>
            <div class="content-quotation-spec">
              <span
                >Quotazione veicolo imm. nel {{ infocar.immatricolazione }}:
                <strong>{{ formatNumber(prezziVendere.valoreAllaData) }} €</strong></span
              >
              <span v-if="prezziVendere.variazioneKm == 0"
                >Variazione introdotta dal chilometraggio:
                <strong>-</strong></span
              >
              <span v-else >
                Variazione introdotta dal chilometraggio:
                <strong>{{ formatNumber(prezziVendere.variazioneKm) }} €</strong></span
              >
              <span v-if="prezziVendere.correttivoAutocarro && prezziVendere.percAutocarro">
                Variazione valore introdotta per immatricolazione come autocarro (-{{
                  prezziVendere.percAutocarro
                }}%): <strong>{{ formatNumber(prezziVendere.correttivoAutocarro) }} €</strong></span
              >
              <span v-if="totalEquipmentsValue !== null">
                Variazione valore introdotta per optional:
                <strong>+{{ formatNumber(prezziVendere.variazioneNoteQualificanti !== null && prezziVendere.variazioneNoteQualificanti !== undefined ? prezziVendere.variazioneNoteQualificanti : totalEquipmentsValue) }} €</strong>
              </span>
            </div>
          </div>
          <div class="container-real-quotation-bottom" :class="[quotationBorderTop]">
            <div class="title-real-quotation text-uppercase" :class="[quotationColor]">
              Quotazione effettiva per cessione a commerciante
            </div>
            <div class="content-real-quotation" :class="[quotationColor]">
              {{ formatNumber(prezziVendere.valoreCommerciale) }} €
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="quotation-bottom-cont" class="container-general">
      <div class="card-quot-bottom card-quot-bottom-left">
        <div class="title-quot" :class="[quotationColor]">
          Quotazione effettiva per comprare
        </div>
        <div class="content-quot" :class="[quotationColor]">
          {{ formatNumber(prezziComprare.valore) }} €
        </div>
        <div class="content-quotation-spec">
          <span
            >Quotazione veicolo imm. nel {{ infocar.immatricolazione }}:
            <strong>{{ formatNumber(prezziComprare.valoreAllaData) }} €</strong></span
          >
          <span v-if="prezziComprare.variazioneKm == 0"
            >Variazione introdotta dal chilometraggio:
            <strong>-</strong></span
          >
          <span v-else >
            Variazione introdotta dal chilometraggio:
            <strong>{{ formatNumber(prezziComprare.variazioneKm) }} €</strong></span
          >
          <span v-if="prezziComprare.correttivoAutocarro && prezziComprare.percAutocarro">
                Variazione valore introdotta per immatricolazione come autocarro (-{{
                  prezziComprare.percAutocarro
                }}%): <strong>{{ formatNumber(prezziComprare.correttivoAutocarro) }} €</strong></span
              >
          <span v-if="totalEquipmentsValue !== null">
            Variazione valore introdotta per optional:
            <strong>+{{ formatNumber(prezziComprare.variazioneNoteQualificanti !== null && prezziComprare.variazioneNoteQualificanti !== undefined ? prezziComprare.variazioneNoteQualificanti : totalEquipmentsValue) }} €</strong>
          </span>
        </div>
      </div>
      <div class="card-quot-bottom card-quot-bottom-right">
        <div class="title-quot" :class="[quotationColor]">
          Quotazione effettiva per assicurare
        </div>
        <div class="content-quot" :class="[quotationColor]">
          {{ formatNumber(prezziAssicurare.valore) }} €
        </div>
        <div class="content-quotation-spec">
          <span
            >Quotazione veicolo imm. nel {{ infocar.immatricolazione }}:
            <strong>{{ formatNumber(prezziAssicurare.valoreAllaData) }} €</strong></span
          >
          <span v-if="prezziAssicurare.variazioneKm == 0"
            >Variazione introdotta dal chilometraggio:
            <strong>-</strong></span
          >
          <span v-else >
            Variazione introdotta dal chilometraggio:
            <strong>{{ formatNumber(prezziAssicurare.variazioneKm) }} €</strong></span
          >
          <span v-if="prezziAssicurare.correttivoAutocarro && prezziAssicurare.percAutocarro">
                Variazione valore introdotta per immatricolazione come autocarro (-{{
                  prezziAssicurare.percAutocarro
                }}%): <strong>{{ formatNumber(prezziAssicurare.correttivoAutocarro) }} €</strong></span
          >
          <span v-if="totalEquipmentsValue !== null">
            Variazione valore introdotta per optional:
            <strong>+{{ formatNumber(prezziAssicurare.variazioneNoteQualificanti !== null && prezziAssicurare.variazioneNoteQualificanti !== undefined ? prezziAssicurare.variazioneNoteQualificanti : totalEquipmentsValue) }} €
            </strong>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificateDefault',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
    prezziVendere: {
      type: Object,
      required: true,
    },
    prezziComprare: {
      type: Object,
      required: true,
    },
    prezziAssicurare: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    vehicle_type: {
      type: String,
      required: false,
    },
  },
  computed: {
    vehicleData() {
      let data = [
        { label: 'Marca', value: this.infocar.marca },
        { label: 'Modello', value: this.infocar.modello },
        { label: 'Allestimento', value: this.infocar.allestimento },
        { label: 'Alimentazione', value: this.infocar.alimentazione },
        { label: 'Carrozzeria', value: this.infocar.carrozzeria },
        { label: 'Immatricolazione', value: this.infocar.immatricolazione },
        { label: 'Km', value: this.formatNumber(this.infocar.km) },
      ];
      if (this.infocar.equipments && this.infocar.equipments.length) {
        this.infocar.equipments.forEach(equipment => {
          data.push({
            label: equipment.descrizione,
            value: this.formatNumber(equipment.valore_abs) + ' €',
          });
        });
      }
      return data;
    },
    quotationColor() {
      return {
        nominale: 'quotation-text-nominale',
        'live-market': 'quotation-text-livemarket',
      }[this.type];
    },
    quotationBorder() {
      return {
        nominale: 'quotation-border-nominale',
        'live-market': 'quotation-border-livemarket',
      }[this.type];
    },
    quotationBorderTop() {
      return {
        nominale: 'quotation-border-top-nominale',
        'live-market': 'quotation-border-top-livemarket',
      }[this.type];
    },
    iconType() {
      return {
        nominale: '../../../images/project-img/Ico-Auto_nominale.svg',
        'live-market': '../../../images/project-img/Ico Auto.svg',
      }[this.type];
    },
    iconTypeVComm() {
      return {
        nominale: '../../../images/project-img/Ico-V-Comm_blu.svg',
      }[this.type];
    },
    logoType() {
      return {
        nominale: '../../../images/project-img/Logo_quotazioni.png',
        'live-market': '../../../images/project-img/quotazioni-livemarket-logo.png',
      }[this.type];
    },
    totalEquipmentsValue() {
  if (this.infocar.equipments && Array.isArray(this.infocar.equipments)) {
    const total = this.infocar.equipments.reduce((total, equipment) => {
      const value = parseFloat(equipment.valore_abs);
      return total + (isNaN(value) ? 0 : value);
    }, 0);

    // Ritorna il valore formattato
    if (total > 0) {
      return `+${total}`;
    } else if (total === 0) {
      return '';
    }
  }
  return null;
},
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) {
        return '';
      }
      // Converti il valore in stringa
      const strValue = value.toString();
      // Sostituisci il punto con una virgola se presente
      const formattedValue = strValue.replace('.', ',');
      const parts = formattedValue.split(',');
      // Format the integer part with dots as thousands separators
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join(',');
    },
  },
};
</script>

<style scoped>
span {
  line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/CertificateDefault.vue